import Call from '../Call';
import {objToQs} from '../Utils';

const DummyCutoff = {
    get(filters) {
        return Call(`dummyCutoff?${objToQs(filters)}`);
    },

    getAll(filters) {
        return Call(`dummyCutoff/all?${objToQs(filters)}`);
    },

    getAffid() {
        return Call(`dummyCutoff/affid`);
    },

    getSubids(filters) {
        return Call(`dummyCutoff/subid?${objToQs(filters)}`);
    },

    getSubidsAll(filters) {
        return Call(`dummyCutoff/subid/all?${objToQs(filters)}`);
    },
    updateFactor(affid, subid, country, cutoff) {
        return Call(`dummyCutoff/factor`, 'PUT', { affid, subid, country, cutoff })
    }
}

export default DummyCutoff;


// WEBPACK FOOTER //
// ./src/services/API/components/DummyCutoff.js